import * as XLSX from "xlsx";

import { IKpiFrequencyData, GenerateExcelOptions } from "../../types/kpi";

export const generateExcelFile = (...dataArrays: object[][]) => {
  const workbook = XLSX.utils.book_new();

  dataArrays.forEach((data: object[], index: number) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const sheetName =
      index === 0 ? "Target vs. Actual" : `Target vs. Actual accumulated`;
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
  return file;
};

export const generateExcelFileWithTitle = (
  options: GenerateExcelOptions,
  ...dataArrays: object[][]
) => {
  const { kpiName, kpiUnit, kpiOwner } = options;

  const workbook = XLSX.utils.book_new();

  dataArrays.forEach((data: object[], index: number) => {
    // Get headers from data
    const headers = Object.keys(data?.[0] || {});

    // Create rows manually
    const worksheetData = [
      ["KPI Export"], // Row 1
      ["KPI Name", kpiName], // Row 2
      ["KPI Unit", kpiUnit], // Row 3
      ["KPI Owner", kpiOwner], // Row 4
      [], // Empty Row
      headers, // Table Header
      ...data.map((item) =>
        headers.map((header) => item[header as keyof typeof item])
      ),
    ];

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Merge first row across all columns
    worksheet["!merges"] = [
      {
        s: { r: 0, c: 0 }, // Start: Row 0 Col 0
        e: { r: 0, c: Math.max(headers.length - 1, 1) }, // End
      },
    ];

    /* Bold Style commented due to not effected on sheet it required to install the library ```xlsx-js-style```
    // Apply bold style
    const boldStyle = {
      font: {
        bold: true}};

    // First row style
    if (worksheet["A1"]) worksheet["A1"].s = boldStyle;

    // KPI rows style
    if (worksheet["A2"]) worksheet["A2"].s = boldStyle;
    if (worksheet["A3"]) worksheet["A3"].s = boldStyle;
*/
    // Table header row style
    const headerRowIndex = 5;

    headers.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({
        r: headerRowIndex - 1,
        c: colIndex});

      // if (worksheet[cellAddress]) {
      //   worksheet[cellAddress].s = boldStyle;
      // }
    });

    // Auto column width
    worksheet["!cols"] = headers.map((header) => ({
      wch: Math.max(header.length + 5, 20)}));

    const sheetName =
      index === 0 ? "Target vs. Actual" : "Target vs. Actual accumulated";

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true});

  return new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
};

export const downloadExcelFile = (...dataArrays: object[][]) => {
  const excelFile = generateExcelFile(...dataArrays);
  const url = URL.createObjectURL(excelFile);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "data.xlsx");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export const modifyFrequencyDataForExcel = (data: IKpiFrequencyData[]) => {
  return data?.map((graphData) => ({
    For: graphData?.name,
    Actual: graphData?.actual,
    Target: graphData?.target}));
};
